import { createAction, props } from "@ngrx/store";
import { AggregateReportActionTypes } from "src/app/constants/StoreConstants";

export const GetStatisticsTableLength = createAction(
  AggregateReportActionTypes.GetStatisticsTableLength,
  props<{uri: string}>()
);

export const GetStatisticsTableLengthSuccess = createAction(
  AggregateReportActionTypes.GetStatisticsTableLengthSuccess,
  props<{result: number}>()
);

export const ResetStatisticsTables = createAction(
  AggregateReportActionTypes.ResetStatisticsTables,
  props<{uri: string, reportType: number}>()
);

export const ResetStatisticsTablesSuccess = createAction(
  AggregateReportActionTypes.ResetStatisticsTablesSuccess,
  props<{result: boolean, reportType: number}>()
)

export const ResetStatisticsState = createAction(
  AggregateReportActionTypes.ResetStatisticsState
);